import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p462904319009685504',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
